export const pinTaskbarShortcutLabel = "Vj2O2d";
export default {pinTaskbarShortcutLabel};